/**
 * Main menu — reference-styled (legionnaire_main_menu.html):
 * LEGIONNAIRE masthead, nav (Skirmish / Campaign / Settings / Codex),
 * commander card, footer. Campaign and Codex are present but disabled —
 * campaign follows skirmish validation (user sequencing), codex after.
 */
export interface MainMenuCallbacks {
  onSkirmish(): void;
  onSettings(): void;
}

export class MainMenu {
  private el: HTMLDivElement;

  constructor(private cb: MainMenuCallbacks) {
    this.el = document.createElement("div");
    this.el.className = "lg-screen";
    this.el.id = "lg-menu";
    this.el.innerHTML =
      `<div class="lg-sky"></div><div class="lg-scrim"></div><div class="lg-vig"></div>` +
      `<div class="lg-body">` +
      `<div class="lg-crumb lg-anim">Senatus Populusque Romanus</div>` +
      `<div class="lg-title lg-anim lg-d1">LEGIONNAIRE</div>` +
      `<div class="lg-sub lg-anim lg-d1">Rome · Samnium · Gaul</div>` +
      `<nav class="lg-nav lg-anim lg-d2" aria-label="Main menu">` +
      `<button class="lg-btn primary" data-act="skirmish">Skirmish</button>` +
      `<button class="lg-btn" data-act="campaign" disabled title="The campaign follows skirmish validation">Campaign — coming soon</button>` +
      `<button class="lg-btn" data-act="settings">Settings</button>` +
      `<button class="lg-btn" data-act="codex" disabled title="The codex follows the campaign">Codex — coming soon</button>` +
      `</nav>` +
      `<div class="lg-card lg-anim lg-d3" style="margin-top:26px;max-width:420px">` +
      `<div class="lg-hd" style="margin-top:0">Commander</div>` +
      `<div class="lg-prose" style="font-size:16px">Marinus — <span class="la-line">Tribunus Militum</span></div>` +
      `<div class="lg-note" style="text-align:left;margin-top:4px">Quick match against the AI. Destroy the enemy command building.</div>` +
      `</div>` +
      `<div class="lg-note lg-anim lg-d3" style="margin-top:22px">Drag — pan · Pinch — zoom · Twist — rotate · Tap — select &amp; order</div>` +
      `</div>`;
    this.el
      .querySelector('[data-act="skirmish"]')!
      .addEventListener("click", () => this.cb.onSkirmish());
    this.el
      .querySelector('[data-act="settings"]')!
      .addEventListener("click", () => this.cb.onSettings());
    document.body.appendChild(this.el);
  }

  show(): void {
    this.el.style.display = "";
  }

  hide(): void {
    this.el.style.display = "none";
  }

  destroy(): void {
    this.el.remove();
  }
}
